import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadVtgkschutzListStatus: 'idle',
    loadVtgkschutzListError: undefined as any,
    loadVtgkschutzListLastArgs: undefined as any,
    loadVtgkschutzStatus: 'idle',
    loadVtgkschutzError: undefined as any,
    saveVtgkschutzStatus: 'idle',
    saveVtgkschutzError: undefined as any,
    deleteVtgkschutzStatus: 'idle',
    deleteVtgkschutzError: undefined as any,

    vtgkschutzList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadVtgkschutzList = createAsyncThunk('vtgkschutzSlice/loadVtgkschutzList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().vtgkschutzSlice.loadVtgkschutzListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/vtgkschutz/?action=eql&FLBELID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVtgkschutzListStatus } = getState().vtgkschutzSlice
        return loadVtgkschutzListStatus !== 'pending'
    }
})

export const loadVtgkschutz = createAsyncThunk('vtgkschutzSlice/loadVtgkschutz', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/vtgkschutz/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadVtgkschutzStatus } = getState().vtgkschutzSlice
        return loadVtgkschutzStatus !== 'pending'
    }
})

export const saveVtgkschutz = createAsyncThunk('vtgkschutzSlice/saveVtgkschutz', async ({ vtgkschutz }: any, { rejectWithValue }: any) => {
    let promises = []
    if (vtgkschutz?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/vtgkschutz/${ vtgkschutz?.HDR_ID }/`,
            prepareData(vtgkschutz),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/vtgkschutz/`,
            prepareData(vtgkschutz),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveVtgkschutzStatus } = getState().vtgkschutzSlice
        return saveVtgkschutzStatus !== 'pending'
    }
})

export const deleteVtgkschutz = createAsyncThunk('vtgkschutzSlice/deleteVtgkschutz', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/vtgkschutz/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteVtgkschutzStatus } = getState().vtgkschutzSlice
        return deleteVtgkschutzStatus !== 'pending'
    }
})

const VtgkschutzSlice = createSlice({
    name: 'vtgkschutzSlice',
    initialState,
    reducers: {
        resetloadVtgkschutzListError: (state) => {
            state.loadVtgkschutzListError = undefined
        },
        resetloadVtgkschutz: (state) => {
            state.formItem = undefined
            state.loadVtgkschutzError = undefined
        },
        resetloadVtgkschutzError: (state) => {
            state.loadVtgkschutzError = undefined
        },
        resetsaveVtgkschutz: (state) => {
            state.formItem = undefined
            state.saveVtgkschutzError = undefined
        },
        resetsaveVtgkschutzError: (state) => {
            state.saveVtgkschutzError = undefined
        },
        resetdeleteVtgkschutzError: (state) => {
            state.deleteVtgkschutzError = undefined
        },
        removeFromVtgkschutzListById: (state, action) => {
            state.vtgkschutzList = state.vtgkschutzList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromVtgkschutzListByIds: (state, action) => {
            state.vtgkschutzList = state.vtgkschutzList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.vtgkschutzList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadVtgkschutzListStatus = 'preloaded'
            state.loadVtgkschutzListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.vtgkschutzList = []
            state.loadVtgkschutzListStatus = 'idle'
            state.loadVtgkschutzListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadVtgkschutzList.pending, (state) => {
            state.loadVtgkschutzListStatus = 'pending'
            state.loadVtgkschutzListError = undefined
        })
        builder.addCase(loadVtgkschutzList.fulfilled, (state, action) => {
            state.loadVtgkschutzListStatus = 'idle'

            if (!action.payload) { return }

            state.loadVtgkschutzListLastArgs = action.payload.args

            {
                state.vtgkschutzList = action.payload.data

            }
        })
        builder.addCase(loadVtgkschutzList.rejected, (state, action) => {
            state.loadVtgkschutzListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVtgkschutzListError = action.error.message
            } else {
                state.loadVtgkschutzListError = action.payload
            }
        })

        builder.addCase(loadVtgkschutz.pending, (state) => {
            state.loadVtgkschutzStatus = 'pending'
            state.loadVtgkschutzError = undefined
        })
        builder.addCase(loadVtgkschutz.fulfilled, (state, action) => {
            state.loadVtgkschutzStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.vtgkschutzList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.vtgkschutzList.push(newItem) }
                else { state.vtgkschutzList[i] = { ...state.vtgkschutzList[i], ...newItem } }
            }
        })
        builder.addCase(loadVtgkschutz.rejected, (state, action) => {
            state.loadVtgkschutzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadVtgkschutzError = action.error.message
            } else {
                state.loadVtgkschutzError = action.payload
            }
        })

        builder.addCase(saveVtgkschutz.pending, (state) => {
            state.saveVtgkschutzStatus = 'pending'
            state.saveVtgkschutzError = undefined
        })
        builder.addCase(saveVtgkschutz.fulfilled, (state, action) => {
            state.saveVtgkschutzStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.vtgkschutzList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.vtgkschutzList.push(newItem) }
                else { state.vtgkschutzList[i] = { ...state.vtgkschutzList[i], ...newItem } }
            }
        })
        builder.addCase(saveVtgkschutz.rejected, (state, action) => {
            state.saveVtgkschutzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveVtgkschutzError = action.error.message
            } else {
                state.saveVtgkschutzError = action.payload
            }
        })

        builder.addCase(deleteVtgkschutz.pending, (state) => {
            state.deleteVtgkschutzStatus = 'pending'
            state.deleteVtgkschutzError = undefined
        })
        builder.addCase(deleteVtgkschutz.fulfilled, (state, action) => {
            state.deleteVtgkschutzStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.vtgkschutzList = state.vtgkschutzList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.vtgkschutzList = state.vtgkschutzList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteVtgkschutz.rejected, (state, action) => {
            state.deleteVtgkschutzStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteVtgkschutzError = action.error.message
            } else {
                state.deleteVtgkschutzError = action.payload
            }
        })

    }
})

export const {
    resetloadVtgkschutzListError,
    resetloadVtgkschutz,
    resetloadVtgkschutzError,
    resetsaveVtgkschutz,
    resetsaveVtgkschutzError,
    resetdeleteVtgkschutzError,
    removeFromVtgkschutzListById,
    removeFromVtgkschutzListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = VtgkschutzSlice.actions
export default VtgkschutzSlice.reducer
